import authImage from "../assets/images/authSvg.svg";
import logo from "assets/images/logoSvg.svg";
import { adminRoutePath } from "config/routeMgt/adminRoutePath";
import { Link } from "react-router-dom";
import "../assets/style.css";
import { ResetPasswordForm } from "../components/ResetPasswordForm";

export const AdminResetPassword = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-screen overflow-auto">
      <div className="Container py-3 bg-white">
        <div className="mt-2">
          <a
            href="https://www.arnopro.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="logo" />
          </a>
        </div>
        <div className="flex justify-center mt-10">
          <div className="authFormWrap">
            <div className="mb-6">
              <h2 className="text-2xl font-bold pb-1 text-primary">
                Reset password
              </h2>
              <p className="text-accent text-sm">Create new password.</p>
            </div>
            <ResetPasswordForm />

            <div className="flex justify-center items-center gap-x-2 text-sm mt-6">
              <span className="text-accent">Want to go back?</span>
              <Link
                to={adminRoutePath.forgot_password}
                className="text-primary font-medium hover:text-accent"
              >
                Forgot password
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-primary h-screen Container lg:flex items-center justify-center hidden w-full sticky top-0">
        <video
          src="/assets/authVideo.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};
